<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { db, firestore } from '@/firebase.config'
import { mapActions } from 'vuex'
export default {
  name: 'App',
  created () {
    let vm = this
    vm.$store.dispatch('setImageQuadAnswersRef', db.ref('imageQuadAnswers'))
    vm.$store.dispatch('setCodeCombosRef', db.ref('codeCombo'))
    // codeCombo
    let scoreArray = []
    firestore.collection('participants').where('timeTaken', '<', 90000).where('timeTaken', '>', 0).where('completed', '==', true).orderBy('timeTaken').limit(10).onSnapshot(function (ref) {
      // console.log('ref', ref)
      scoreArray = []
      ref.forEach(score => {
        scoreArray.push(score.data())
      })
      vm.updateLeaderboard(scoreArray)
    })
    // db.ref('codes').once('value').then(snapshot => {
    //   snapshot.forEach(childSnapshot => {
    //     console.log(childSnapshot.val())
    //     firestore.collection('participants').doc(childSnapshot.val().code).set({
    //       entered: false
    //     })
    //   })
    // })
  },
  methods: {
    ...mapActions([
      'updateLeaderboard'
    ])
  }
}
</script>

<style>
#app {
  font-family: 'open-sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  background: radial-gradient(#fff, #fff, #CFD1D2);
}
</style>



// WEBPACK FOOTER //
// src/App.vue